import axios from "axios";
import React from "react";
import { Redirect, useHistory } from "react-router";
import { Input, InputGroup } from "rsuite";
import { AppRouteApi, AppRouteUi } from "../../../config/appRoute";
import { ApiResponseContainer } from "../../../models/api";
import eyeIcon from "../../../assets/img/eye-icon.svg";
import { AuthLayout } from "../../components/authLayout";
import { Button } from "../../../components/button.component";

type ApiBodyResetPassword = {
  emailAddress: string;
  confirmationCode: string;
  newPassword: string;
  confirmPassword: string;
};

export function PageAuthResetPassword(): JSX.Element {
  const [showPassword, toggleShowPassword] = React.useReducer(
    (prev) => !prev,
    false
  );
  const [showPasswordConfirm, toggleShowPasswordConfirm] = React.useReducer(
    (prev) => !prev,
    false
  );
  const [code, setCode] = React.useState<string>();
  const [email, setEmail] = React.useState<string>();
  const [isBusy, setIsBusy] = React.useState<boolean>(false);
  const [password, setPassword] = React.useState<string>();
  const [passwordConfirm, setPasswordConfirm] = React.useState<string>();
  const [msg, setMsg] = React.useState<string>();
  const { push: historyPush } = useHistory();
  const onPasswordReset = React.useCallback(
    async (body: ApiBodyResetPassword) => {
      setIsBusy(true);
      try {
        const response = await axios.post<ApiResponseContainer<{}>>(
          AppRouteApi.Auth.ChangePasswordWithCode(),
          body
        );
        if (response.data.isSuccess)
          historyPush({
            pathname: AppRouteUi.Login.Root(),
            state: { passwordReset: true, from: "reset" },
          });
        else setMsg(response.data.message);
      } catch (e) {
        setMsg(String(e));
      }
      setIsBusy(false);
    },
    [historyPush]
  );

  return (
    <AuthLayout>
      <div className="px-3">
        <h4 className="text-center fw-light my-3">Reset Password</h4>
        {!msg ? (
          <div>
            <InputGroup className="mb-2">
              <Input
                placeholder="Email"
                onChange={(value) => setEmail(`${value}`)}
              />
            </InputGroup>
            <InputGroup className="mb-2">
              <Input
                placeholder="New Password"
                type={showPassword ? "text" : "password"}
                onChange={(value) => setPassword(`${value}`)}
              />
              <InputGroup.Addon>
                <img
                  src={eyeIcon}
                  alt="View"
                  className="click"
                  height={15}
                  onClick={toggleShowPassword}
                />
              </InputGroup.Addon>
            </InputGroup>
            <InputGroup className="mb-2">
              <Input
                placeholder="Confirm Password"
                type={showPasswordConfirm ? "text" : "password"}
                onChange={(value) => setPasswordConfirm(`${value}`)}
              />
              <InputGroup.Addon>
                <img
                  src={eyeIcon}
                  alt="View"
                  className="click"
                  height={15}
                  onClick={toggleShowPasswordConfirm}
                />
              </InputGroup.Addon>
            </InputGroup>
            <InputGroup className="mb-2">
              <Input
                placeholder="Code"
                onChange={(value) => setCode(`${value}`)}
              />
            </InputGroup>
            <div className="d-flex justify-content-center">
              <Button
                onClick={() =>
                  code &&
                  email &&
                  password &&
                  passwordConfirm &&
                  onPasswordReset({
                    emailAddress: email,
                    newPassword: password,
                    confirmPassword: passwordConfirm,
                    confirmationCode: code,
                  })
                }
                disabled={!code || !email || !password || !passwordConfirm}
                loading={isBusy}
                name="Reset"
                className="mt-3 px-5 btn-green"
              />
            </div>
          </div>
        ) : (
          <Redirect
            to={{
              pathname: AppRouteUi.Login.Root(),
              state: { passwordReset: false, from: "reset" },
            }}
          />
        )}
      </div>
    </AuthLayout>
  );
}
